import { render, staticRenderFns } from "./AuthorCard.vue?vue&type=template&id=319c3995&scoped=true&"
import script from "./AuthorCard.vue?vue&type=script&lang=js&"
export * from "./AuthorCard.vue?vue&type=script&lang=js&"
import style0 from "./AuthorCard.vue?vue&type=style&index=0&id=319c3995&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@3.6.0_webpack@5.90.3__handlebars@4.7.8_lodash@4.17.21_und_7a413cb3c088a52b1b49cb1af70714d5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319c3995",
  null
  
)

export default component.exports